// Vanuatu National Curriculum - Primary Assessments
// Quiz and Test assessments for Years 1-6 that sync with Grade Book batch entry

export const primaryAssessments = {
  // English (Language & Communication)
  english: {
    subject: "English",
    strands: ["Listening & Speaking", "Reading", "Writing", "Viewing"],
    years: {
      year1: {
        assessments: [
          {
            id: "eng-y1-quiz-s1-1",
            type: "Quiz",
            strand: "Listening & Speaking",
            title: "Listening & Speaking Quiz 1",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "listening",
                question: "Listen to the teacher and point to the correct picture.",
                instructions: "Teacher reads: 'The dog is running.'",
                marks: 2
              },
              {
                id: 2,
                type: "oral",
                question: "Say your name clearly to the class.",
                marks: 2
              },
              {
                id: 3,
                type: "oral",
                question: "Name 3 things you can see in the classroom.",
                marks: 3
              },
              {
                id: 4,
                type: "listening",
                question: "Follow the teacher's instructions: 'Stand up, turn around, sit down.'",
                marks: 3
              }
            ]
          },
          {
            id: "eng-y1-quiz-s2-1",
            type: "Quiz",
            strand: "Reading",
            title: "Reading & Phonics Quiz 1",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "matching",
                question: "Match the letter to the picture that starts with that sound.",
                options: ["A - Apple", "B - Ball", "C - Cat"],
                marks: 3
              },
              {
                id: 2,
                type: "multiple_choice",
                question: "Which letter makes the 'sss' sound?",
                options: ["A", "S", "M", "T"],
                correctAnswer: "S",
                marks: 2
              },
              {
                id: 3,
                type: "reading",
                question: "Read the word: CAT",
                marks: 2
              },
              {
                id: 4,
                type: "reading",
                question: "Read the word: DOG",
                marks: 3
              }
            ]
          },
          {
            id: "eng-y1-quiz-s3-1",
            type: "Quiz",
            strand: "Writing",
            title: "Writing & Handwriting Quiz 1",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "writing",
                question: "Write your first name on the line.",
                marks: 2
              },
              {
                id: 2,
                type: "tracing",
                question: "Trace and copy these letters: A a B b C c",
                marks: 3
              },
              {
                id: 3,
                type: "writing",
                question: "Write the missing letter: _at (c), _og (d), _un (s)",
                correctAnswer: "cat, dog, sun",
                marks: 3
              },
              {
                id: 4,
                type: "drawing",
                question: "Draw a picture and write one word about it.",
                marks: 2
              }
            ]
          },
          {
            id: "eng-y1-quiz-s3-2",
            type: "Quiz",
            strand: "Writing",
            title: "Letter Formation Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 2",
            questions: [
              {
                id: 1,
                type: "tracing",
                question: "Trace and write these uppercase letters: D E F G H",
                marks: 3
              },
              {
                id: 2,
                type: "tracing",
                question: "Trace and write these lowercase letters: d e f g h",
                marks: 3
              },
              {
                id: 3,
                type: "writing",
                question: "Copy the word: BALL",
                marks: 2
              },
              {
                id: 4,
                type: "writing",
                question: "Write a word that starts with B.",
                marks: 2
              }
            ]
          },
          {
            id: "eng-y1-test-writing-1",
            type: "Test",
            strand: "Writing",
            title: "Term 1 Writing Test",
            totalMarks: 15,
            timeLimit: "25 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "writing",
                question: "Write all the letters of your name correctly.",
                marks: 3
              },
              {
                id: 2,
                type: "tracing",
                question: "Copy these words neatly: cat, dog, sun, run, big",
                marks: 5
              },
              {
                id: 3,
                type: "writing",
                question: "Write the first letter of each picture's name.",
                instructions: "Pictures shown: Apple, Ball, Cat, Dog, Egg",
                marks: 5
              },
              {
                id: 4,
                type: "drawing",
                question: "Draw your favorite animal and write its name.",
                marks: 2
              }
            ]
          },
          {
            id: "eng-y1-test-1",
            type: "Test",
            strand: "Reading",
            title: "End of Term 1 Reading Test",
            totalMarks: 20,
            timeLimit: "30 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "matching",
                question: "Match the uppercase letter to the lowercase letter.",
                pairs: [["A", "a"], ["B", "b"], ["C", "c"], ["D", "d"], ["E", "e"]],
                marks: 5
              },
              {
                id: 2,
                type: "phonics",
                question: "Circle the pictures that start with the letter 'M'.",
                marks: 5
              },
              {
                id: 3,
                type: "reading",
                question: "Read these simple words: cat, dog, sun, run, big",
                marks: 5
              },
              {
                id: 4,
                type: "comprehension",
                question: "Listen to the story and answer: What color was the ball?",
                marks: 5
              }
            ]
          }
        ]
      },
      year2: {
        assessments: [
          {
            id: "eng-y2-quiz-s1-1",
            type: "Quiz",
            strand: "Listening & Speaking",
            title: "Listening & Speaking Quiz 1",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "listening",
                question: "Listen to the short story and answer questions.",
                marks: 4
              },
              {
                id: 2,
                type: "oral",
                question: "Describe what you did yesterday using 3 sentences.",
                marks: 3
              },
              {
                id: 3,
                type: "oral",
                question: "Ask a classmate a question about their family.",
                marks: 3
              }
            ]
          },
          {
            id: "eng-y2-quiz-s2-1",
            type: "Quiz",
            strand: "Reading",
            title: "Reading Comprehension Quiz 1",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "reading",
                question: "Read the passage and answer: Who is the main character?",
                marks: 3
              },
              {
                id: 2,
                type: "vocabulary",
                question: "What does the word 'happy' mean?",
                options: ["Sad", "Glad", "Mad", "Bad"],
                correctAnswer: "Glad",
                marks: 2
              },
              {
                id: 3,
                type: "comprehension",
                question: "What happened at the end of the story?",
                marks: 5
              }
            ]
          },
          {
            id: "eng-y2-quiz-s3-1",
            type: "Quiz",
            strand: "Writing",
            title: "Writing Quiz 1",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "writing",
                question: "Write your full name in neat handwriting.",
                marks: 2
              },
              {
                id: 2,
                type: "writing",
                question: "Write a sentence about your favorite food.",
                marks: 4
              },
              {
                id: 3,
                type: "writing",
                question: "Copy this sentence: The bird is in the tree.",
                marks: 4
              }
            ]
          }
        ]
      },
      year3: {
        assessments: [
          {
            id: "eng-y3-quiz-s1-1",
            type: "Quiz",
            strand: "Listening & Speaking",
            title: "Oral Communication Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "oral",
                question: "Introduce yourself in English (name, age, where you live).",
                marks: 4
              },
              {
                id: 2,
                type: "listening",
                question: "Listen to the instructions and follow them correctly.",
                marks: 3
              },
              {
                id: 3,
                type: "oral",
                question: "Describe your family using at least 4 sentences.",
                marks: 3
              }
            ]
          },
          {
            id: "eng-y3-quiz-s2-1",
            type: "Quiz",
            strand: "Reading",
            title: "Reading Comprehension Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "reading",
                question: "Read the passage about village life.",
                passage: "Maria lives in a small village. She walks to school every day. Her favorite subject is Mathematics.",
                subQuestions: [
                  { q: "Where does Maria live?", marks: 2 },
                  { q: "How does she get to school?", marks: 2 },
                  { q: "What is her favorite subject?", marks: 2 }
                ],
                marks: 6
              },
              {
                id: 2,
                type: "vocabulary",
                question: "Find words in the passage that mean: small, likes most",
                marks: 4
              }
            ]
          },
          {
            id: "eng-y3-test-1",
            type: "Test",
            strand: "Writing",
            title: "Term 1 English Test",
            totalMarks: 20,
            timeLimit: "40 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "grammar",
                question: "Fill in the blanks with is/are: The dog ___ running. The cats ___ sleeping.",
                marks: 4
              },
              {
                id: 2,
                type: "writing",
                question: "Write 5 sentences about your school.",
                marks: 8
              },
              {
                id: 3,
                type: "punctuation",
                question: "Add capital letters and full stops: the boy went to the market he bought some bananas",
                marks: 4
              },
              {
                id: 4,
                type: "spelling",
                question: "Spell these words correctly: skool, happi, becoz, frend, beautifull",
                marks: 4
              }
            ]
          }
        ]
      },
      year4: {
        assessments: [
          {
            id: "eng-y4-quiz-s1-1",
            type: "Quiz",
            strand: "Listening & Speaking",
            title: "Oral Presentation Skills Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "eng-y4-quiz-s2-1",
            type: "Quiz",
            strand: "Reading",
            title: "Reading Comprehension Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "eng-y4-quiz-s3-1",
            type: "Quiz",
            strand: "Writing",
            title: "Creative Writing Quiz",
            totalMarks: 10,
            timeLimit: "25 minutes",
            term: "Term 1"
          },
          {
            id: "eng-y4-test-1",
            type: "Test",
            strand: "Writing",
            title: "Term 1 English Test",
            totalMarks: 20,
            timeLimit: "45 minutes",
            term: "Term 1"
          }
        ]
      },
      year5: {
        assessments: [
          {
            id: "eng-y5-quiz-s1-1",
            type: "Quiz",
            strand: "Listening & Speaking",
            title: "Discussion & Debate Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "eng-y5-quiz-s2-1",
            type: "Quiz",
            strand: "Reading",
            title: "Fiction & Non-Fiction Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "eng-y5-test-1",
            type: "Test",
            strand: "Reading",
            title: "Term 1 Reading Comprehension Test",
            totalMarks: 20,
            timeLimit: "45 minutes",
            term: "Term 1"
          }
        ]
      },
      year6: {
        assessments: [
          {
            id: "eng-y6-quiz-s1-1",
            type: "Quiz",
            strand: "Listening & Speaking",
            title: "Formal Speaking Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "eng-y6-quiz-s2-1",
            type: "Quiz",
            strand: "Reading",
            title: "Literary Analysis Quiz",
            totalMarks: 10,
            timeLimit: "25 minutes",
            term: "Term 1"
          },
          {
            id: "eng-y6-test-1",
            type: "Test",
            strand: "Writing",
            title: "Term 1 Essay Writing Test",
            totalMarks: 20,
            timeLimit: "50 minutes",
            term: "Term 1"
          }
        ]
      }
    }
  },
  
  // Mathematics
  mathematics: {
    subject: "Mathematics",
    strands: ["Number", "Measurement", "Geometry", "Patterns", "Chance & Data"],
    years: {
      year1: {
        assessments: [
          {
            id: "math-y1-quiz-s1-1",
            type: "Quiz",
            strand: "Number",
            title: "Counting & Numbers Quiz 1",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "counting",
                question: "Count the objects: How many apples are there? 🍎🍎🍎🍎🍎",
                correctAnswer: 5,
                marks: 2
              },
              {
                id: 2,
                type: "number_recognition",
                question: "Circle the number 7: 3, 5, 7, 9, 2",
                correctAnswer: 7,
                marks: 2
              },
              {
                id: 3,
                type: "ordering",
                question: "Put these numbers in order from smallest to biggest: 5, 2, 8, 1",
                correctAnswer: "1, 2, 5, 8",
                marks: 3
              },
              {
                id: 4,
                type: "addition",
                question: "2 + 3 = ?",
                correctAnswer: 5,
                marks: 3
              }
            ]
          },
          {
            id: "math-y1-quiz-s2-1",
            type: "Quiz",
            strand: "Geometry",
            title: "Shapes Quiz 1",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1",
            questions: [
              {
                id: 1,
                type: "shape_recognition",
                question: "Name this shape: ⭕",
                correctAnswer: "Circle",
                marks: 2
              },
              {
                id: 2,
                type: "shape_recognition",
                question: "Name this shape: ▢",
                correctAnswer: "Square",
                marks: 2
              },
              {
                id: 3,
                type: "shape_recognition",
                question: "Name this shape: △",
                correctAnswer: "Triangle",
                marks: 3
              },
              {
                id: 4,
                type: "shape_counting",
                question: "How many sides does a triangle have?",
                correctAnswer: 3,
                marks: 3
              }
            ]
          },
          {
            id: "math-y1-test-1",
            type: "Test",
            strand: "Number",
            title: "Term 1 Mathematics Test",
            totalMarks: 20,
            timeLimit: "30 minutes",
            term: "Term 1"
          }
        ]
      },
      year2: {
        assessments: [
          {
            id: "math-y2-quiz-s1-1",
            type: "Quiz",
            strand: "Number",
            title: "Addition & Subtraction Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "math-y2-quiz-s2-1",
            type: "Quiz",
            strand: "Measurement",
            title: "Length & Time Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "math-y2-test-1",
            type: "Test",
            strand: "Number",
            title: "Term 1 Mathematics Test",
            totalMarks: 20,
            timeLimit: "30 minutes",
            term: "Term 1"
          }
        ]
      },
      year3: {
        assessments: [
          {
            id: "math-y3-quiz-s1-1",
            type: "Quiz",
            strand: "Number",
            title: "Multiplication Tables Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1",
            questions: [
              { id: 1, type: "multiplication", question: "3 × 4 = ?", correctAnswer: 12, marks: 2 },
              { id: 2, type: "multiplication", question: "5 × 5 = ?", correctAnswer: 25, marks: 2 },
              { id: 3, type: "multiplication", question: "2 × 7 = ?", correctAnswer: 14, marks: 2 },
              { id: 4, type: "multiplication", question: "6 × 3 = ?", correctAnswer: 18, marks: 2 },
              { id: 5, type: "multiplication", question: "4 × 4 = ?", correctAnswer: 16, marks: 2 }
            ]
          },
          {
            id: "math-y3-quiz-s2-1",
            type: "Quiz",
            strand: "Measurement",
            title: "Money & Time Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "math-y3-quiz-s3-1",
            type: "Quiz",
            strand: "Geometry",
            title: "Shapes & Symmetry Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "math-y3-test-1",
            type: "Test",
            strand: "Number",
            title: "Term 1 Mathematics Test",
            totalMarks: 20,
            timeLimit: "40 minutes",
            term: "Term 1"
          }
        ]
      },
      year4: {
        assessments: [
          {
            id: "math-y4-quiz-s1-1",
            type: "Quiz",
            strand: "Number",
            title: "Place Value & Operations Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "math-y4-quiz-s2-1",
            type: "Quiz",
            strand: "Measurement",
            title: "Perimeter & Area Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "math-y4-test-1",
            type: "Test",
            strand: "Number",
            title: "Term 1 Mathematics Test",
            totalMarks: 20,
            timeLimit: "45 minutes",
            term: "Term 1"
          }
        ]
      },
      year5: {
        assessments: [
          {
            id: "math-y5-quiz-s1-1",
            type: "Quiz",
            strand: "Number",
            title: "Fractions & Decimals Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "math-y5-quiz-s2-1",
            type: "Quiz",
            strand: "Patterns",
            title: "Number Patterns Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "math-y5-test-1",
            type: "Test",
            strand: "Number",
            title: "Term 1 Mathematics Test",
            totalMarks: 20,
            timeLimit: "45 minutes",
            term: "Term 1"
          }
        ]
      },
      year6: {
        assessments: [
          {
            id: "math-y6-quiz-s1-1",
            type: "Quiz",
            strand: "Number",
            title: "Percentages & Ratios Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "math-y6-quiz-s2-1",
            type: "Quiz",
            strand: "Chance & Data",
            title: "Probability & Statistics Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "math-y6-test-1",
            type: "Test",
            strand: "Number",
            title: "Term 1 Mathematics Test",
            totalMarks: 20,
            timeLimit: "50 minutes",
            term: "Term 1"
          }
        ]
      }
    }
  },
  
  // Science - Official strands from Vanuatu National Curriculum Years 4-6
  science: {
    subject: "Science",
    strands: ["Living Things & Environment", "Interactions of Matter", "Energy & Everyday Life", "Our Earth & Space", "Agriculture"],
    years: {
      year1: {
        assessments: [
          {
            id: "sci-y1-quiz-s1-1",
            type: "Quiz",
            strand: "Living Things & Environment",
            title: "Plants & Animals Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y1-test-1",
            type: "Test",
            strand: "Living Things & Environment",
            title: "Term 1 Science Test",
            totalMarks: 20,
            timeLimit: "30 minutes",
            term: "Term 1"
          }
        ]
      },
      year2: {
        assessments: [
          {
            id: "sci-y2-quiz-s1-1",
            type: "Quiz",
            strand: "Living Things & Environment",
            title: "Life Cycles Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y2-quiz-s2-1",
            type: "Quiz",
            strand: "Interactions of Matter",
            title: "Materials Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y2-test-1",
            type: "Test",
            strand: "Living Things & Environment",
            title: "Term 1 Science Test",
            totalMarks: 20,
            timeLimit: "30 minutes",
            term: "Term 1"
          }
        ]
      },
      year3: {
        assessments: [
          {
            id: "sci-y3-quiz-s1-1",
            type: "Quiz",
            strand: "Living Things & Environment",
            title: "Food Chains Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y3-quiz-s2-1",
            type: "Quiz",
            strand: "Energy",
            title: "Light & Sound Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y3-test-1",
            type: "Test",
            strand: "Living Things & Environment",
            title: "Term 1 Science Test",
            totalMarks: 20,
            timeLimit: "40 minutes",
            term: "Term 1"
          }
        ]
      },
      year4: {
        assessments: [
          {
            id: "sci-y4-quiz-s1-1",
            type: "Quiz",
            strand: "Living Things & Environment",
            title: "Ecosystems Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y4-quiz-s2-1",
            type: "Quiz",
            strand: "Interactions of Matter",
            title: "States of Matter Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y4-test-1",
            type: "Test",
            strand: "Living Things & Environment",
            title: "Term 1 Science Test",
            totalMarks: 20,
            timeLimit: "45 minutes",
            term: "Term 1"
          }
        ]
      },
      year5: {
        assessments: [
          {
            id: "sci-y5-quiz-s1-1",
            type: "Quiz",
            strand: "Living Things & Environment",
            title: "Human Body Systems Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y5-quiz-s2-1",
            type: "Quiz",
            strand: "Earth & Space",
            title: "Solar System Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y5-test-1",
            type: "Test",
            strand: "Living Things & Environment",
            title: "Term 1 Science Test",
            totalMarks: 20,
            timeLimit: "45 minutes",
            term: "Term 1"
          }
        ]
      },
      year6: {
        assessments: [
          {
            id: "sci-y6-quiz-s1-1",
            type: "Quiz",
            strand: "Living Things & Environment",
            title: "Cells & Genetics Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y6-quiz-s2-1",
            type: "Quiz",
            strand: "Energy",
            title: "Forces & Motion Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "sci-y6-test-1",
            type: "Test",
            strand: "Living Things & Environment",
            title: "Term 1 Science Test",
            totalMarks: 20,
            timeLimit: "50 minutes",
            term: "Term 1"
          }
        ]
      }
    }
  },
  
  // Social Science - Official strands from Vanuatu National Curriculum Years 4-6
  socialScience: {
    subject: "Social Science",
    strands: ["Our Cultural Heritage & Identity", "Civics & Community Relationships", "Enterprise"],
    years: {
      year1: {
        assessments: [
          {
            id: "ss-y1-quiz-s1-1",
            type: "Quiz",
            strand: "Our Cultural Heritage & Identity",
            title: "Culture & Family Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "ss-y1-test-1",
            type: "Test",
            strand: "Civics & Community Relationships",
            title: "Term 1 Social Science Test",
            totalMarks: 20,
            timeLimit: "30 minutes",
            term: "Term 1"
          }
        ]
      },
      year2: {
        assessments: [
          {
            id: "ss-y2-quiz-s1-1",
            type: "Quiz",
            strand: "Civics & Community Relationships",
            title: "Family & Community Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "ss-y2-test-1",
            type: "Test",
            strand: "Civics & Community Relationships",
            title: "Term 1 Social Science Test",
            totalMarks: 20,
            timeLimit: "30 minutes",
            term: "Term 1"
          }
        ]
      },
      year3: {
        assessments: [
          {
            id: "ss-y3-quiz-s1-1",
            type: "Quiz",
            strand: "Enterprise",
            title: "Culture & Traditions Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "ss-y3-quiz-s2-1",
            type: "Quiz",
            strand: "Our Cultural Heritage & Identity",
            title: "Safety & First Aid Quiz",
            totalMarks: 10,
            timeLimit: "15 minutes",
            term: "Term 1"
          },
          {
            id: "ss-y3-test-1",
            type: "Test",
            strand: "Civics & Community Relationships",
            title: "Term 1 Social Science Test",
            totalMarks: 20,
            timeLimit: "40 minutes",
            term: "Term 1"
          }
        ]
      },
      year4: {
        assessments: [
          {
            id: "ss-y4-quiz-s1-1",
            type: "Quiz",
            strand: "Civics & Community Relationships",
            title: "Local Government Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "ss-y4-test-1",
            type: "Test",
            strand: "Civics & Community Relationships",
            title: "Term 1 Social Science Test",
            totalMarks: 20,
            timeLimit: "45 minutes",
            term: "Term 1"
          }
        ]
      },
      year5: {
        assessments: [
          {
            id: "ss-y5-quiz-s1-1",
            type: "Quiz",
            strand: "Our Cultural Heritage & Identity",
            title: "Puberty & Health Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "ss-y5-quiz-s2-1",
            type: "Quiz",
            strand: "Enterprise",
            title: "Vanuatu History Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "ss-y5-test-1",
            type: "Test",
            strand: "Civics & Community Relationships",
            title: "Term 1 Social Science Test",
            totalMarks: 20,
            timeLimit: "45 minutes",
            term: "Term 1"
          }
        ]
      },
      year6: {
        assessments: [
          {
            id: "ss-y6-quiz-s1-1",
            type: "Quiz",
            strand: "Civics & Community Relationships",
            title: "Citizenship & Rights Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "ss-y6-quiz-s2-1",
            type: "Quiz",
            strand: "Enterprise",
            title: "Pacific Cultures Quiz",
            totalMarks: 10,
            timeLimit: "20 minutes",
            term: "Term 1"
          },
          {
            id: "ss-y6-test-1",
            type: "Test",
            strand: "Civics & Community Relationships",
            title: "Term 1 Social Science Test",
            totalMarks: 20,
            timeLimit: "50 minutes",
            term: "Term 1"
          }
        ]
      }
    }
  }
};

// Helper function to get assessments by subject, year, and strand
export const getPrimaryAssessments = (subject, year, strand = null) => {
  const subjectKey = subject.toLowerCase().replace(/\s+/g, '');
  const subjectData = primaryAssessments[subjectKey] || primaryAssessments.english;
  const yearKey = `year${year}`;
  const yearData = subjectData?.years?.[yearKey];
  
  if (!yearData?.assessments) return [];
  
  if (strand) {
    return yearData.assessments.filter(a => a.strand === strand);
  }
  return yearData.assessments;
};

// Get strands for a primary subject
export const getPrimaryStrands = (subject) => {
  const subjectKey = subject.toLowerCase().replace(/\s+/g, '');
  return primaryAssessments[subjectKey]?.strands || [];
};

export default primaryAssessments;
